import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-048caaa5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-deletion" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Account Deletion", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you wish to delete your account, please confirm your request below. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" This action is irreversible. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password:", -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "success"
}
const _hoisted_8 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitDeletionRequest && _ctx.submitDeletionRequest(...args)), ["prevent"]))
      }, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          id: "email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "password",
          id: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          required: "",
          minlength: "6"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.isSubmitting
        }, _toDisplayString(_ctx.isSubmitting ? 'Processing...' : 'Delete My Account'), 9, _hoisted_6)
      ], 32),
      (_ctx.successMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.successMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}